// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__vOUij","text":"SelectPayment_text__2LIGh","title":"SelectPayment_title__1cgp5","btn":"SelectPayment_btn__10MU7"};